var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMyAcct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.439,
    height: 22.955,
    viewBox: "0 0 19.439 22.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-myAcct",
    transform: "translate(0.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17108",
    "data-name": "Rectangle 17108",
    width: 15.51,
    height: 20.086,
    rx: 3,
    transform: "translate(0 2.119)",
    fill: "none",
    stroke: "#017dba",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12360",
    "data-name": "Path 12360",
    d: "M1256.286,39.538h-4.359a1.079,1.079,0,0,1-1.09-1.061h0a1.079,1.079,0,0,1,1.09-1.061h4.359a1.079,1.079,0,0,1,1.089,1.061h0A1.079,1.079,0,0,1,1256.286,39.538Z",
    transform: "translate(-1247.802 -30.121)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12361",
    "data-name": "Path 12361",
    d: "M1256.286,46.628h-4.359a1.079,1.079,0,0,1-1.09-1.061h0a1.079,1.079,0,0,1,1.09-1.061h4.359a1.079,1.079,0,0,1,1.089,1.061h0A1.079,1.079,0,0,1,1256.286,46.628Z",
    transform: "translate(-1247.802 -33.449)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1619",
    "data-name": "Ellipse 1619",
    cx: 1.09,
    cy: 1.061,
    rx: 1.09,
    ry: 1.061,
    transform: "translate(10.663 6.236)",
    fill: "#0eb4d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1620",
    "data-name": "Ellipse 1620",
    cx: 1.09,
    cy: 1.061,
    rx: 1.09,
    ry: 1.061,
    transform: "translate(10.663 11.057)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12362",
    "data-name": "Path 12362",
    d: "M1256.286,53.711h-4.359a1.079,1.079,0,0,1-1.09-1.061h0a1.079,1.079,0,0,1,1.09-1.061h4.359a1.079,1.079,0,0,1,1.089,1.061h0A1.079,1.079,0,0,1,1256.286,53.711Z",
    transform: "translate(-1247.802 -36.775)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1621",
    "data-name": "Ellipse 1621",
    cx: 1.09,
    cy: 1.061,
    rx: 1.09,
    ry: 1.061,
    transform: "translate(10.663 14.813)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1622",
    "data-name": "Ellipse 1622",
    cx: 5.01,
    cy: 5.01,
    r: 5.01,
    transform: "translate(8.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12363",
    "data-name": "Path 12363",
    d: "M1270.891,33.67l-.167-.02a.218.218,0,1,1,.035-.434c.209,0,.42.019.627,0a3.178,3.178,0,0,0,2.149-5.209,2.951,2.951,0,0,0-.644-.581c.031.135.059.255.085.375a.217.217,0,0,1-.124.251.212.212,0,0,1-.258-.068.322.322,0,0,1-.049-.115c-.065-.277-.127-.554-.19-.832a.22.22,0,0,1,.182-.288l.838-.192a.221.221,0,0,1,.284.152.218.218,0,0,1-.18.271c-.111.028-.223.052-.343.08.091.07.174.13.254.2a3.573,3.573,0,0,1,1.235,1.988c.033.141.053.285.079.428v.763c0,.018-.01.036-.013.054-.032.165-.054.334-.1.5a3.605,3.605,0,0,1-2.987,2.645c-.107.014-.214.025-.321.038Z",
    transform: "translate(-1257.039 -25.02)",
    fill: "#00aafc",
    stroke: "#00aafc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12364",
    "data-name": "Path 12364",
    d: "M1268.109,26.069l.173.024a.216.216,0,0,1-.041.43,6.439,6.439,0,0,0-.656,0,3.1,3.1,0,0,0-2.053,1.023,3.04,3.04,0,0,0-.807,1.781,3.091,3.091,0,0,0,.764,2.444,6.341,6.341,0,0,0,.516.478.574.574,0,0,0,.055.037c-.03-.135-.06-.26-.086-.387a.217.217,0,1,1,.424-.095q.1.43.2.859a.22.22,0,0,1-.183.283l-.839.191a.223.223,0,0,1-.286-.159.22.22,0,0,1,.184-.264c.1-.025.2-.047.3-.071l.012-.013c-.018-.015-.036-.031-.055-.045a3.478,3.478,0,0,1-1.361-2.08,3.617,3.617,0,0,1,2.845-4.374c.127-.025.256-.034.385-.051.021,0,.041-.008.061-.012Z",
    transform: "translate(-1254.109 -24.793)",
    fill: "#007dba",
    stroke: "#00aafc",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMyAcct);
export default __webpack_public_path__ + "static/media/icn-myAcct.a026e01745036d1a6e4a28ab6fb6cd65.svg";
export { ForwardRef as ReactComponent };